import { getAssetBaseUrl } from '../utils';

import {
    IIconAssetMap, IIconAssetMapSignature,
} from './Icon.assets.interface';
import { ICON_COLOR } from './Icon.colors';
import { ICON_TYPE } from './Icon.types';

const assetBaseURL = getAssetBaseUrl();

const ASSETS = {
    accountAvatar: `${assetBaseURL}/account_avatar.svg`,
    arrowDark: `${assetBaseURL}/arrow_right_dark.svg`,
    arrowLight: `${assetBaseURL}/arrow_right_light.svg`,
    arrowPrimary: `${assetBaseURL}/arrow_right_primary.svg`,
    arrowUpDark: `${assetBaseURL}/arrow_up_dark.svg`,
    arrowDownDark: `${assetBaseURL}/arrow_down_dark.svg`,
    closeDark: `${assetBaseURL}/close_dark.svg`,
    closeGray: `${assetBaseURL}/close_gray.svg`,
    closeLight: `${assetBaseURL}/close_light.svg`,
    facebookLight: `${assetBaseURL}/facebook_light.svg`,
    facebookDark: `${assetBaseURL}/facebook_dark.svg`,
    helpTip: `${assetBaseURL}/help_tip.svg`,
    instagramLight: `${assetBaseURL}/instagram_light.svg`,
    instagramDark: `${assetBaseURL}/instagram_dark.svg`,
    promoCodeTag: `${assetBaseURL}/promo_code_tag.svg`,
    tiktokLight: `${assetBaseURL}/tiktok_light.svg`,
    tiktokDark: `${assetBaseURL}/tiktok_dark.svg`,
    twitterLight: `${assetBaseURL}/twitter_light.svg`,
    twitterDark: `${assetBaseURL}/twitter_dark.svg`,
    youtubeLight: `${assetBaseURL}/youtube_light.svg`,
    youtubeDark: `${assetBaseURL}/youtube_dark.svg`,
    clockTimer: `${assetBaseURL}/clock.svg`,
    sandTimer: `${assetBaseURL}/sand_timer.svg`,
    charityIcon: `${assetBaseURL}/charity_icon.svg`,
};

export const ICON_ASSET_MAP: IIconAssetMap = {
    [ICON_TYPE.OZ_YOUTUBE]: {
        [ICON_COLOR.DARK]: ASSETS.youtubeDark,
        [ICON_COLOR.LIGHT]: ASSETS.youtubeLight,
        DEFAULT: ASSETS.youtubeLight,
    },
    [ICON_TYPE.OZ_INSTAGRAM]: {
        [ICON_COLOR.DARK]: ASSETS.instagramDark,
        [ICON_COLOR.LIGHT]: ASSETS.instagramLight,
        DEFAULT: ASSETS.instagramLight,
    },
    [ICON_TYPE.OZ_TIKTOK]: {
        [ICON_COLOR.DARK]: ASSETS.tiktokDark,
        [ICON_COLOR.LIGHT]: ASSETS.tiktokLight,
        DEFAULT: ASSETS.tiktokLight,
    },
    [ICON_TYPE.OZ_TWITTER]: {
        [ICON_COLOR.DARK]: ASSETS.twitterDark,
        [ICON_COLOR.LIGHT]: ASSETS.twitterLight,
        DEFAULT: ASSETS.twitterLight,
    },
    [ICON_TYPE.OZ_FACEBOOK]: {
        [ICON_COLOR.DARK]: ASSETS.facebookDark,
        [ICON_COLOR.LIGHT]: ASSETS.facebookLight,
        DEFAULT: ASSETS.facebookLight,
    },
    [ICON_TYPE.OZ_ACCOUNT_AVATAR]: {
        [ICON_COLOR.DARK]: ASSETS.accountAvatar,
        DEFAULT: ASSETS.accountAvatar,
    },
    [ICON_TYPE.OZ_CLOSE]: {
        [ICON_COLOR.DARK]: ASSETS.closeDark,
        [ICON_COLOR.LIGHT]: ASSETS.closeLight,
        [ICON_COLOR.GRAY]: ASSETS.closeGray,
        DEFAULT: ASSETS.closeDark,
    },
    [ICON_TYPE.OZ_ARROW_RIGHT]: {
        [ICON_COLOR.PRIMARY]: ASSETS.arrowPrimary,
        [ICON_COLOR.DARK]: ASSETS.arrowDark,
        [ICON_COLOR.LIGHT]: ASSETS.arrowLight,
        DEFAULT: ASSETS.arrowPrimary,
    },
    [ICON_TYPE.OZ_ARROW_UP]: {
        [ICON_COLOR.DARK]: ASSETS.arrowUpDark,
        DEFAULT: ASSETS.arrowUpDark,
    },
    [ICON_TYPE.OZ_ARROW_DOWN]: {
        [ICON_COLOR.DARK]: ASSETS.arrowDownDark,
        DEFAULT: ASSETS.arrowDownDark,
    },
    [ICON_TYPE.OZ_HELP_TIP]: {
        [ICON_COLOR.DARK]: ASSETS.helpTip,
        DEFAULT: ASSETS.helpTip,
    },
    [ICON_TYPE.OZ_PROMO_TAG]: {
        [ICON_COLOR.DARK]: ASSETS.promoCodeTag,
        DEFAULT: ASSETS.promoCodeTag,
    },
    [ICON_TYPE.OZ_CLOCK_TIMER]: {
        [ICON_COLOR.DARK]: ASSETS.clockTimer,
        DEFAULT: ASSETS.clockTimer,
    },
    [ICON_TYPE.OZ_SAND_TIMER]: {
        [ICON_COLOR.DARK]: ASSETS.sandTimer,
        DEFAULT: ASSETS.sandTimer,
    },
    [ICON_TYPE.OZ_CHARITY_ICON]: {
        [ICON_COLOR.DARK]: ASSETS.charityIcon,
        DEFAULT: ASSETS.charityIcon,
    },
};

export const getIconAsset = (type: string, color?: ICON_COLOR): string => {
    const DEFAULT: string = 'DEFAULT';
    const iconTypeMap: IIconAssetMapSignature = ICON_ASSET_MAP[type];

    if (iconTypeMap && color && iconTypeMap[color]) {
        return iconTypeMap[color] || '';
    }

    return (iconTypeMap && iconTypeMap[DEFAULT]) || '';
};
